import React, {useCallback, useEffect, useState} from 'react';

const Leaderboard = (props) => {
  const handleGameStateChanged = props.handleGameStateChanged
  const handleSetStale = props.handleSetStale
  const handleSetPhase = props.handleSetPhase
  const handleGameCodeChanged = props.handleGameCodeChanged
  const handleStartNewGame = props.handleStartNewGame

  const [pointsPerUser, setPointsPerUser] = useState({})
  const [isLoadingScores, setIsLoadingScores] = useState(true)
  const [isGameOver, setIsGameOver] = useState(false)
  const [countdownSecond, setCountdownSecond] = useState(45);

  useEffect(() => {
    const nextRoundTimer = setTimeout(() => {
      setCountdownSecond(countdownSecond - 1);
      if (!isLoadingScores && !isGameOver && countdownSecond <= 1) {
        console.log("next round")
        handleGameStateChanged({newPhase: 2, newJudge: '', newPhoto: ''});
        clearTimeout(nextRoundTimer);
      }
    }, 1000);
  }, [handleGameStateChanged, countdownSecond, isLoadingScores, isGameOver]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (props.scores.length > 0) {
        let pointsPerUser = {}
        for (let i = 0; i < props.scores.length; i++) {
          if (pointsPerUser.hasOwnProperty(props.scores[i].GameParticipantID)) {
            pointsPerUser[props.scores[i].GameParticipantID] += props.scores[i].Points

            // check if user has won, but continue to calculate all scores
            if (pointsPerUser[props.scores[i].GameParticipantID] >= (props.gameState?.WinningScore || 500)) {
              setIsGameOver(true)
            }

          } else {
            pointsPerUser[props.scores[i].GameParticipantID] = props.scores[i].Points
          }
        }

        for (let i = 0; i < props.gameParticipants.length; i++) {
          if (!pointsPerUser.hasOwnProperty(props.gameParticipants[i].Name)) {
            pointsPerUser[props.gameParticipants[i].Name] = 0
          }
        }

        const sortedPointsPerUser = Object.entries(pointsPerUser).sort(
          (a, b) => b[1] - a[1]);

        setPointsPerUser(sortedPointsPerUser)
        setIsLoadingScores(false)
        clearTimeout(timer)
      }
    }, 500);
  }, [props.scores, props.gameParticipants, props.gameState?.WinningScore]);

  const addScoreboard = useCallback(() => {
    if (isLoadingScores) {
      return (
        <div
          className="w-screen h-screen fixed top-0 left-0 bg-gray-900 opacity-75
          bg-[url('https://media.giphy.com/media/8agqybiK5LW8qrG3vJ/giphy.gif')] bg-center bg-no-repeat z-10">
        </div>
      )
    }

    let scoreBoard;
    scoreBoard = Object.keys(pointsPerUser).map((index, _) => {
      return (
        <>
          <div key={`${pointsPerUser[index][0]}-user`}
               className="p-1 border border-black border-r-0 text-black font-bold text-left">
            {pointsPerUser[index][0]}
          </div>
          <div key={`${pointsPerUser[index][0]}-score`}
               className="p-1 border border-black border-l-0 text-black font-bold text-left">
            {pointsPerUser[index][1]}
          </div>
        </>
      )
    });

    return scoreBoard
    }, [pointsPerUser, isLoadingScores]
  );

  return (
    <>
      {isGameOver &&
        <>
          <div className="w-screen h-screen fixed top-0 left-0 bg-gray-900 opacity-90 justify-center bg-center bg-no-repeat z-10">
            <div className="w-[80%] flex absolute top-[50px] text-6xl font-bold justify-center text-blue-900 bg-white border border-black mx-[10%] p-4 rounded-lg">{pointsPerUser[0][0]}</div>
            <img className="w-[50%] mx-[25%] absolute top-[270px] h-auto my-8 border-[3px] rounded-xl border-gray-500 justify-center"
                 src="https://media.giphy.com/media/lZTvTGEGKU6gnQ2wBr/giphy.gif"
                 alt="Winner, Winner, Chicken Dinner" />
            <div className="w-[80%] flex absolute bottom-[70px] text-xl justify-center content-center items-center text-blue-900 hover:text-blue-500 hover:cursor-pointer bg-white border border-black mx-[10%] p-4 rounded-lg">
              <a onClick={handleStartNewGame}>➡ New game</a>
            </div>
          </div>

          <div className="mt-[10%] mx-6 border border-black rounded-xl grid place-items-center">
            <div className="p-[5%]">
              <h1 className="text-4xl font-bold text-center text-black">Final Score</h1>
            </div>
          </div>
        </>
      }

      {!isGameOver &&
        <>
          <div className="mt-[10%] mx-6 border border-black rounded-xl grid place-items-center">
            <div className="p-[5%]">
              <h1 className="text-4xl font-bold text-center text-black">Leaderboard</h1>

              { !isLoadingScores && countdownSecond > 0 &&
                <h3 className="mt-5 text-gray-950 text-xl">Next round in <span className="font-bold text-xl">{countdownSecond}</span> seconds</h3>}
            </div>
          </div>
        </>
      }

      <div className="mt-4 mx-auto w-full mb-6">
        <div className="basis-1/4 border border-black rounded-xl p-4 mt-10 mx-8">
          <h3
            className="relative right-6 bottom-6 mr-16 bg-gradient-to-r rounded-xl py-1 from-cyan-500 to-blue-500 text-white text-center">
            Scores
          </h3>
          <div className="grid grid-cols-2 gap-y-3 px-[5%]">
            {addScoreboard()}
          </div>
        </div>
      </div>
    </>
  )
}

export default Leaderboard;
